// extracted by mini-css-extract-plugin
export default {"yellowGradBg":"ColorGradient_yellowGradBg__rSrlX"};